export default __webpack_public_path__ + "static/media/img_sinFotoCreate.03f4705a.jpg";